import { Directive, ElementRef, HostListener, Input, Renderer2, OnInit } from '@angular/core';
@Directive({
  selector: '[resizeRow]',
  standalone: false
})
export class ResizeRowDirective implements OnInit {
  @Input() resizeRow: any;
  @Input() index: number = 0;
  @Input() minHeight: number = 38;
  @Input() maxHeight: number = 300;
private startY: number = 0;
  private startHeight: number = 0;
  private resizer: HTMLElement | null = null;
  private isResizing: boolean = false;
  private rowElement: HTMLElement;
constructor(private el: ElementRef, private renderer: Renderer2) {
    this.rowElement = this.el.nativeElement;
  }
ngOnInit() {
    this.resizer = this.renderer.createElement('div');
    this.renderer.addClass(this.resizer, 'row-resizer');
this.renderer.appendChild(this.rowElement, this.resizer);
this.renderer.setStyle(this.rowElement, 'position', 'relative');
if (this.resizer) {
      this.renderer.listen(this.resizer, 'mousedown', (event) => this.onMouseDown(event));
    }
  }
private onMouseDown(event: MouseEvent) {
    event.preventDefault();
this.startY = event.pageY;
    this.startHeight = this.rowElement.offsetHeight;
    this.isResizing = true;
this.renderer.listen('document', 'mousemove', (e) => this.onMouseMove(e));
    this.renderer.listen('document', 'mouseup', () => this.onMouseUp());
this.renderer.addClass(document.body, 'row-resizing');
  }
private onMouseMove(event: MouseEvent) {
    if (!this.isResizing) return;
const offset = event.pageY - this.startY;
    let newHeight = this.startHeight + offset;
if (newHeight < this.minHeight) newHeight = this.minHeight;
    if (newHeight > this.maxHeight) newHeight = this.maxHeight;
this.renderer.setStyle(this.rowElement, 'height', `${newHeight}px`);
if (this.resizeRow) {
      this.resizeRow.height = `${newHeight}px`;
    }
  }
private onMouseUp() {
    this.isResizing = false;
    this.renderer.removeClass(document.body, 'row-resizing');
  }
}   